import React, { FunctionComponent } from "react";

interface IProps {
    notification: Spintr.INotification;
}

const StudioAppMessageNotification: FunctionComponent<IProps> = (props) => {
    const notification = props.notification as Spintr.IStudioAppMessageNotification;
    if (!notification) {
        return null;
    }

    return <span>{notification.appName}: {notification.body}</span>;
};

export default StudioAppMessageNotification;
